import React, { useContext, useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { 
    Box,
    List,
    Button,
    Icon
} from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import Divider from '@mui/material/Divider';

import ProjectContext from '../contexts/ProjectContext';
import { useAbortController } from '../contexts/AbortControllerContext';

import ItemList from '../components/menuitem/ItemList';
import ExportsRightClick from '../components/rightclicks/ExportsRightClick';
import FullDataGrid from '../components/datagrid/FullDataGrid';
import SecondaryButton from '../components/buttons/SecondaryButton';
import DownloadButton from '../components/buttons/DownloadButton';
import DownloadIcon from '@mui/icons-material/Download';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import RequestButton from '../components/buttons/RequestButton';
import ErrorIcon from '@mui/icons-material/Error';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {useFetch} from '../components/auth/useFetch';

// In milliseconds
let minimumLoadingAnimationDuration = 2000;

export default function ExportView(props) {
    const { transferdate, makeTour, setIsLoading } = props
    const { isAuthenticated } = useAuth0();
    const { abortGroupRequests, registerController, unregisterController } = useAbortController()
    const projectContext = useContext(ProjectContext);

    const [exports, setExports] = useState([])
    const [jsonData, setJsonData] = useState([])
    const [jsonDataTrunc, setJsonDataTrunc] = useState([])
    const [activeIndex, setActiveIndex] = useState(null)
    const [exportData, setExportData] = useState(null)
    const [pdfUrl, setPdfUrl] = useState(null)
    const [isLoading, setLoading] = useState(false)
    const [loadingFailed, setLoadingFailed] = useState(false)
    const [showCopySuccess, setShowCopySuccess] = useState(false)
    const fetchWithAuth = useFetch()

    

    const itemStyle = {
        background:"red"
    }

    useEffect(() => {
        setIsLoading(true)
        const url = `${process.env.REACT_APP_BACKEND_URL}/konsol/exportale/`
        const exportAleController = registerController(``)
        isAuthenticated && (async () => {
        try {
            await fetchWithAuth(url, {
                headers:{
                    'X-Project-ID': projectContext?.project_db
                },
                signal: exportAleController.signal
            })
                .then((response) => response.json())
                .then((res) => {
                    const excludedTypes = ["Sync", "Injection"];
                    const filtered = res.filter(item => !excludedTypes.includes(item.type));
                    setExports(filtered)
                    setTimeout(() => {
                        setIsLoading(false)
                    }, 1000)
                })
        } catch (e) {
            if(e.name !== 'AbortError'){
            console.error(e);
            }
        } finally {
            unregisterController(exportAleController)
        }
        })();
    }, [isAuthenticated])

    useEffect(() => {
        makeTour([
            {
                title: 'Exports',
                target: '#export-view-exports',
                content: 'All the configured exports can be found here. Click on one of them to load the preview. Click on the download button to download it instead.',
                placementBeacon: 'left',
                placement: 'right'
            },
            {
                title: 'Exports',
                target: '#export-view-exports-preview',
                content: 'All the configured exports can be found here. Click on one of them to load the preview. Click on the download button to download it instead.',
                placement: 'right',
                placementBeacon: 'right',
                locale: {
                    next: 'Finish',
                }
            },
        ])
    }, [])

    const previewExport = async (index) => {
        abortGroupRequests(`${transferdate}.export.preview`)
        const payload = {'transfer_date': [transferdate]}
        const previewExportController = registerController(`${transferdate}.export.preview`)
        setActiveIndex(index)
        setExportData(null)
        setPdfUrl(null)
        let url
        if(exports[index]?.type === 'ALE'){
            url = `${process.env.REACT_APP_BACKEND_URL}/konsol/ale/?output_type=preview&output_format=ale&ale_name=${exports[index]['name']}`
        }
        else if(exports[index]?.type === 'CSV'){
            url = `${process.env.REACT_APP_BACKEND_URL}/konsol/ale/?output_type=preview&output_format=csv&ale_name=${exports[index]['name']}`
        }
        else if(exports[index]?.type === 'PDF'){
            url = `${process.env.REACT_APP_BACKEND_URL}/konsol/generatepdf/?output_type=pdf&pdf_name=${exports[index]['name']}`
        }
        else if(exports[index]?.type === 'ARCHIVE'){
            url = `${process.env.REACT_APP_BACKEND_URL}/konsol/assets/?output_type=pdf&pdf_name=${exports[index]['name']}`
        }
        else if(exports[index]['name'].includes('MovieLabs')){
            url = `${process.env.REACT_APP_BACKEND_URL}/konsol/mlabsjson/?output_type=json_preview&json_name=${exports[index]["name"]}`
        }
        // Begin counting to ensure loading anim plays for a decent length of time
        setIsLoading(true)
        setLoading(true)
        let startTime = new Date();

        try{
        const response = await fetchWithAuth(url, {
            method: 'POST',
            headers: {
                'X-Project-ID': projectContext?.project_db,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload),
            signal: previewExportController.signal,
        })

        // Handle loading anim time
        let endTime = new Date();
        if (endTime.getTime() - startTime.getTime() < minimumLoadingAnimationDuration){
        let waitTime = minimumLoadingAnimationDuration - (endTime.getTime() - startTime.getTime());
        setTimeout(()=>{
            setIsLoading(false)
            setLoading(false)
        }, waitTime)
        } else {
            setLoading(false)
            setIsLoading(false)
        }



        const fetch_success = await response.status
        if (fetch_success !== 200 ){
            setLoadingFailed(true);
        } else{
            setLoadingFailed(false);
        }
        if(exports[index]?.type === 'ALE' || exports[index]?.type === 'CSV'){
            const res = await response.json()
            setExportData(res)
        }
        else if(exports[index]?.type === 'PDF' || exports[index]?.type === 'ARCHIVE'){
            const res = await response.blob()
            setPdfUrl(URL.createObjectURL(res))
        }
        if(exports[index]?.type === 'JSON' || exports[index]?.type === 'ARCHIVE'){
            const truncate_limit = 20000
            const res = await response.json()
            let full_json = JSON.stringify(res, null, "  ")
            setJsonData(full_json)
            let truncated_json = JSON.stringify(res, null, "  ").substring(0, truncate_limit)
            if (full_json.length > truncated_json.length){
                truncated_json = truncated_json + "...\n\n\nVery large file generated. Download or copy to clipboard to see full file.\n \n \n \n \n \n \n \n \n \n \n \n"
            }
            setJsonDataTrunc(truncated_json)
        }
        } catch(e) {
            if(e.name !== 'AbortError'){
                console.error(e);
            }
        } finally {
            unregisterController(previewExportController, `${transferdate}.export.preview`)
        }

    }

    async function downloadExport (index) {
        const payload = {'transfer_date': [transferdate]}
        let url
        if(exports[index]?.type === 'ALE'){
            url = `${process.env.REACT_APP_BACKEND_URL}/konsol/ale/?output_type=ale&output_format=ale&ale_name=${exports[index]['name']}`
        }
        else if(exports[index]?.type === 'CSV'){
            url = `${process.env.REACT_APP_BACKEND_URL}/konsol/ale/?output_type=csv&output_format=csv&ale_name=${exports[index]['name']}`
        }
        else if(exports[index]?.type === 'PDF'){

            url = `${process.env.REACT_APP_BACKEND_URL}/konsol/generatepdf/?output_type=pdf&pdf_name=${exports[index]['name']}`
        }
        else if(exports[index]?.type === 'ARCHIVE'){
            url = `${process.env.REACT_APP_BACKEND_URL}/konsol/assets/?output_type=pdf&pdf_name=${exports[index]['name']}`
        }
        else if(exports[index]?.type === 'SQL'){
            url = `${process.env.REACT_APP_BACKEND_URL}/konsol/downloadsql/?output_type=pdf&pdf_name=${exports[index]['name']}`
        }
        else if(exports[index]['name'].includes('MovieLabs')){
            url = `${process.env.REACT_APP_BACKEND_URL}/konsol/mlabsjson/?output_type=json_file&json_name=${exports[index]['name']}`
        }

        try {
        let response = await fetchWithAuth(url, {
            method: 'POST',
            headers: {
                'X-Project-ID': projectContext?.project_db,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload),
        })
        let blob = await response.blob()
        url = window.URL.createObjectURL(blob);
        let ext
        if(exports[index]?.type === 'ALE'){
            ext = '.ALE'
        }
        else if(exports[index]?.type === 'PDF' || exports[index]?.type === 'ARCHIVE'){
            ext = '.PDF'
        }
        else if(exports[index]?.type === 'JSON'){
            ext = '.json'
        }
        else{
            ext = ''
        }
        const filename = `${transferdate}-${exports[index]['name']}${ext}`

        // Return essential data to calling function 
        return {'url': url, 'filename':filename, 'status': response.status}
        } catch(e) {
            console.error(e);
        }
    }

    const resultsStyle = {
        transition: '0.5s',
        // TODO: Gross use of a fixed height - calculate better
        height: '100%',
        overflow: 'auto',
        marginTop: '10px'
    }

    const jsonCodeStyle = {
        height: '100%',
        width: '100%',
        marginBottom: '300px'
    }

    async function copyTextClick(){
        try{
            navigator.clipboard.writeText(jsonData)
            setShowCopySuccess(true)
            setTimeout(function(){
                setShowCopySuccess(false)
            }, 3000)
        } catch (error){
            setShowCopySuccess(false)
        }
    }
  
    async function pushExport(event, transferdate){
        event.preventDefault();

        let fetchDetails = {
            method: "POST",
            headers: { 
                "Content-type": "application/json; charset=UTF-8",
                'X-Project-ID': projectContext?.project_db
            },
            body: JSON.stringify({"transfer_date": transferdate}),
        }
        try{
        let request = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/pushto/`,
            fetchDetails
        )
        let response = await request.json()

        // if (request.status == 500){
        //     throw new Error(response)
        // }
        return(response)
        } catch(e) {
            console.error(e);
        }
    }

    async function pushSync(event, transferdate){
        event.preventDefault();
        let fetchDetails = {
            method: "PATCH",
            headers: { 
                "Content-type": "application/json; charset=UTF-8",
                'X-Project-ID': projectContext?.project_db
            },
            body: JSON.stringify({"transfer_date": transferdate}),
        }
        try{
        let request = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/pushto/`,
            fetchDetails
        )
        let response = await request.json()

        if (request.status != 200){
            throw new Error()
        }
        } catch(e) {
            console.error(e);
        }
    }



    function renderPreview(){
        if (isLoading){
            return(
                <>
                    <LinearProgress 
                    sx={{
                        backgroundColor:'rgba(0,0,0,0)',
                        '& .MuiLinearProgress-bar':{
                            backgroundColor:'green'
                        }
                        
                    }}
                    />
                    <Box style={{position:'relative', margin:'auto', width:'50%', top:'30%', display:'flex', flexDirection:'column', alignItems:'center'}}>
                        
                        <div style={{
                            textAlign: 'center',
                            width:'100%', 
                            top:'50px',
                            fontSize: 'large'}}>
                                Generating Preview
                        </div>
                    </Box>
                </>
            )
        } else if (exports[activeIndex]?.type === 'ALE' || exports[activeIndex]?.type === 'CSV' && loadingFailed === false){
            return(
                <FullDataGrid rows={exportData?.rows} columns={exportData?.columns}  disableSelection/>
            )
        } else if ((exports[activeIndex]?.type === 'PDF' || exports[activeIndex]?.type === 'ARCHIVE') && loadingFailed === false){
            return(
                <embed 
                    src={pdfUrl} 
                    type='application/pdf' 
                    width='100%' 
                    height='100%'
                />
            )
        } else if ((exports[activeIndex]?.type === 'JSON' || exports[activeIndex]?.type === 'ARCHIVE') && loadingFailed === false){
            return(
                <Box style={resultsStyle} sx={{
                    marginTop: '40px',
                    backgroundColor: 'white',
                    padding: '20px',
                    borderRadius: '10px',
                    color:'black',
                    height: '100%'
                }}>
                    
                    <Button onClick={copyTextClick} style={{margin: 0}}> 
                        <ContentCopyIcon></ContentCopyIcon>
                        <div style={{transition: "0.3s", marginLeft: 10, opacity: showCopySuccess? 1 : 0}}>Copied to clipboard</div>
                    </Button>
                    <pre style={jsonCodeStyle}>{jsonDataTrunc}</pre>
                </Box>
            )
        } else if (loadingFailed){
            return(
                <Box style={{position:'relative', margin:'auto', width:'50%', top:'30%', display:'flex', flexDirection:'column', alignItems:'center'}}>
                    <div style={{
                        textAlign: 'center',
                        width:'100%', 
                        top:'50px',
                        fontSize: 'large'}}>
                            Resource not available
                    </div>
                    <br></br>
                    <ErrorIcon fontSize='large' color='red'></ErrorIcon>
                </Box>
            )
        }
    }

    return (
        <React.Fragment>
            <Box
                display="flex"
                flexDirection={{xs: 'column', md: 'row'}}
                height='100%'
                width='100%'
            >
                <Box
                    id='export-view-exports'
                    height={{xs: '25%', md: '100%'}}
                    width={{xs: '100%', md: '300px'}}
                    bgcolor='rgba(0,0,0,0.9)'
                    overflow={'auto'}
                    flexShrink={0}
                    
                >
                    <List sx={{
                        color: 'white',
                        width: '100%',
                        paddingTop: '0px'
                    }}
                        
                    >
                        {exports.map((exp, index) => {
                            return (
                                <ExportsRightClick
                                    key={index}
                                    active={index === activeIndex}
                                    exports={exp}
                                    filename={`${transferdate}-${exports?.name}_override.PDF`}
                                    payload={{'transfer_date': [transferdate]}}
                                >
                                    <ItemList
                                        active={index === activeIndex ? true : false}
                                        title={exp['name']} 
                                        label={exp['type']} 
                                        onItemClick={() => previewExport(index)}
                                        iconButton={
                                            exp['type']=='PUSH' ?
                                            <>
                                                <RequestButton
                                                    iconOnly={true}
                                                    icon= {<CloudUploadIcon/>}
                                                    requestFunc={pushExport}
                                                    requestArgs={[transferdate]}
                                                />
                                            </>
                                            :
                                                <DownloadButton
                                                downloadParams = {() => downloadExport(index)}
                                                hoverColor='white'
                                                color='silver'
                                                iconOnly={true}
                                                />
                                        }
                                    />
                                </ExportsRightClick>
                            )
                        })}
                    </List>
                </Box>
                <Divider 
                        orientation={{md: "vertical", xs:"horizontal"}}
                        sx={{ 
                            borderBottomWidth: 5,
                            borderRightWidth: 5,
                            backgroundColor:"rgb(30 80 60)"
                        }}
                    />
                <Box 
                    height={'100%'} 
                    width ={'100%'}
                    overflow="auto"
                >
                    <Box  height={'100%'} width={'100%'} bgcolor={'black'}>
                        {renderPreview()}
                    </Box>
                </Box>
            </Box>
        </React.Fragment>
    )
}